import { forwardRef, type ComponentProps } from 'react';
import { PostalCodeInput } from '../../atoms/postal-code-input.component';
import { FieldLayoutWithAction } from '../../layouts/field-layout-with-action';
import type { BasicFormFieldProps, ExtraFieldProps, FieldActionProps } from '../../layouts/types';

type Props = BasicFormFieldProps<'postalCode'> & ExtraFieldProps & FieldActionProps;

export const PostalCodeField = forwardRef<HTMLDivElement, Props>((props, ref) => (
  <FieldLayoutWithAction
    {...props}
    //TODO: this might be able to be improved. But this type cast just makes sure the field prop is any of the correct field types
    field={PostalCodeInput as ComponentProps<typeof FieldLayoutWithAction>['field']}
    ref={ref}
  />
));

PostalCodeField.displayName = 'PostalCodeField';
